module.exports = __webpack_public_path__ + "img/ios5.b70185d2.png";